// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { B400, B50, N0, N20, N30, R400 } from '@atlaskit/theme/colors';
import { layers } from '@atlaskit/theme/constants';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var PopupComponentContainer = styled.div({
  boxSizing: 'border-box',
  display: 'block',
  flex: '1 1 auto',
  overflow: 'visible',
  borderRadius: "var(--ds-border-radius-100, 4px)",
  background: "var(--ds-background-input, ".concat(N0, ")"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  ':focus': {
    outline: 'none'
  },
  boxShadow: "var(--ds-shadow-overlay, 0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 3px 5px 0px rgba(9, 30, 66, 0.20))"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var CustomDropdown = styled.div({
  width: '340px',
  background: "var(--ds-background-input, ".concat(N0, ")"),
  borderRadius: "var(--ds-border-radius-100, 4px)",
  boxShadow: "var(--ds-shadow-overlay, 0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 3px 5px 0px rgba(9, 30, 66, 0.20))",
  zIndex: layers.modal()
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export var CustomDropdownItem = styled.div(function (props) {
  return {
    height: '36px',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingLeft: props.isSelected ? '15px' : '16px',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: props.isSelected ? "var(--ds-text-selected, ".concat(B400, ")") : 'inherit',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: props.isSelected ? "var(--ds-background-accent-blue-subtlest, ".concat(B50, ")") : 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderLeft: props.isSelected ? "2px solid ".concat("var(--ds-text-selected, ".concat(B400, ")")) : 'none',
    '&:hover': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
      background: props.isSelected ? "var(--ds-background-accent-blue-subtlest, ".concat(B50, ")") : "var(--ds-background-input-hovered, ".concat(N20, ")"),
      cursor: 'default'
    }
  };
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var CustomDateWrapper = styled.div({
  padding: "var(--ds-space-150, 12px)",
  boxSizing: 'border-box'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var DatePickersWrapper = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var SelectDateRangeButton = styled.button({
  background: "var(--ds-background-accent-gray-subtler, ".concat(N20, ")"),
  border: 'none',
  font: 'inherit',
  width: '70px',
  height: '40px',
  marginTop: "var(--ds-space-150, 12px)",
  borderRadius: "var(--ds-border-radius-100, 4px)",
  '&:hover': {
    background: "var(--ds-background-accent-gray-subtler, ".concat(N30, ")"),
    cursor: 'pointer'
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var DateRangeErrorMessage = styled.div({
  display: 'flex',
  marginTop: "var(--ds-space-050, 2px)",
  gap: "var(--ds-space-025, 2px)",
  paddingInlineStart: "var(--ds-space-025, 2px)",
  font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
  color: "var(--ds-text-danger, ".concat(R400, ")"),
  alignItems: 'center'
});